import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, debounceTime, map, switchMap, tap } from 'rxjs/operators';
import { CallerService } from 'src/app/services/caller.service';
import { newMessage, profileUpdateError, profileUpdateSuccess, updateCorpMemberProfile } from '../actions/corp-member.actions';
import { Router } from '@angular/router';



@Injectable()
export class CorpMemberEffects {

  // @todo: can this be improved?
  updateProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCorpMemberProfile),
      debounceTime(500),
      switchMap((data) => this.callerService.updateProfile(data).pipe(
        tap((res) => console.log('what tapppp?', res)),
        map(res => profileUpdateSuccess({data: res.body})),
        catchError(() => of(profileUpdateError()))
      ))
    )
  );

  newChatMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(newMessage),
      debounceTime(100),
      tap((data) => {
        // after a new message action is gotten, navigate to the messages page
        this.router.navigate(['/messages'], { queryParams: { r: data?.recipient_id, i: data?.initiator_id } })
      }),
    ),
    { dispatch: false } // No need to dispatch any action after this effect
  );

  constructor(private actions$: Actions, 
    private router: Router,
    private callerService: CallerService) {}
}
